import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LOAI_FORM, LOAI_PHIEU_KHO, TT_PHIEU_KHO} from "types/enums";
import {glassStoreService} from "api";
import Notification from "components/common/notification/notification";
type State = {
  typePhieu: LOAI_PHIEU_KHO;
  idPhieu: string | number;
  selectGlassSupplies: any[];
  selectGlass: any[];
  statusPhieu: TT_PHIEU_KHO;
  typeForm: LOAI_FORM;
  khoXuatId: number | string;
  listStore: any[];
  listLoaiVT: any[];
  listGlassInStore: any[];
  listSupplier: any[];
  listXuatXu: any[];
  totalGlassInStore: number;
  selectedRecord: any; // bản ghi phiếu đc chọn
  detailRecord: any;
  listStoreNhap;
  listStoreXuat;
};

const initialState: State = {
  typePhieu: null,
  idPhieu: null,
  selectGlassSupplies: [],
  selectGlass: [],
  statusPhieu: null,
  typeForm: null,
  khoXuatId: null,
  listStore: [],
  listStoreNhap: [],
  listStoreXuat: [],
  listLoaiVT: null,
  listGlassInStore: [],
  listSupplier: [],
  listXuatXu: [],
  totalGlassInStore: 0,
  selectedRecord: null,
  detailRecord: null,
};

export const glassStoreSlice = createSlice({
  name: "glassStore",
  initialState: initialState,
  reducers: {
    setTypePhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typePhieu: action.payload};
    },
    setStatusPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        statusPhieu: action.payload,
      };
    },
    setTypeForm: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        typeForm: action.payload,
      };
    },

    setIdPhieu: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idPhieu: actions.payload,
      };
    },
    setSelectGlassSupplies: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        selectGlassSupplies: actions.payload,
      };
    },
    setSelectGlassExport: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        selectGlass: actions.payload,
      };
    },

    setKhoXuatId: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        khoXuatId: actions.payload,
      };
    },
    setListStore: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listStore: actions.payload,
      };
    },
    setListStoreNhap: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listStoreNhap: actions.payload,
      };
    },
    setListStoreXuat: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listStoreXuat: actions.payload,
      };
    },
    setListLoaiVT: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listLoaiVT: actions.payload,
      };
    },
    setListGlassInStore: (state = initialState, action: PayloadAction<any>) => {
      state.listGlassInStore = action.payload.listGlassInStore;
      state.totalGlassInStore = action.payload.totalGlassInStore;
    },
    setListSupplier: (state = initialState, action: PayloadAction<any>) => {
      state.listSupplier = action.payload.listSupplier;
      // state.totalGlassInStore = action.payload.totalGlassInStore;
    },
    setListXuatXu: (state = initialState, action: PayloadAction<any>) => {
      state.listXuatXu = action.payload.listXuatXu;
      // state.totalGlassInStore = action.payload.totalGlassInStore;
    },
    setSelectedRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, selectedRecord: action.payload};
    },
    setDetailRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailRecord: action.payload};
    },
  },
});

export const getListStore = () => {
  return async dispatch => {
    try {
      const listStore = (await glassStoreService.getListStore(1, 20)) || [];
      dispatch(setListStore(listStore.data));
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho kính");
    }
  };
};
export const getListStorePhanQuyen = () => {
  return async dispatch => {
    try {
      const listStore =
        (await glassStoreService.getListStorePhanQuyen({page: 1, limit: 20})) ||
        [];
      dispatch(setListStore(listStore.data));
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho kính");
    }
  };
};
export const getListStoreNhap = () => {
  return async dispatch => {
    try {
      const listStoreNhap =
        (await glassStoreService.getListStorePhanQuyen({
          page: 1,
          limit: 20,
          type: "NH",
        })) || [];
      dispatch(setListStoreNhap(listStoreNhap.data));
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho kính");
    }
  };
};
export const getListStoreXuat = () => {
  return async dispatch => {
    try {
      const listStoreXuat =
        (await glassStoreService.getListStorePhanQuyen({
          page: 1,
          limit: 20,
          type: "XU",
        })) || [];
      dispatch(setListStoreXuat(listStoreXuat.data));
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho kính");
    }
  };
};
export const updateDetailLo = params => {
  return async dispatch => {
    try {
      const res = (await glassStoreService.updateDetailLo(params)) || null;
      Notification("success", "Đã cập nhật thông tin lô");
    } catch (error) {
      Notification(
        "error",
        error?.response?.data ?? "Đã có lỗi xảy ra khi cập nhật thông tin lô"
      );
    }
  };
};
export const getListLoaiVTAPI = () => {
  return async dispatch => {
    try {
      const res = (await glassStoreService.getListSuppliesType()) || [];

      dispatch(setListLoaiVT(res));
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách loại vật tư");
    }
  };
};
export const getListGlassInStoreAPI = params => {
  return async dispatch => {
    try {
      const res = await glassStoreService.getListGlassInStore(params);
      dispatch(
        setListGlassInStore({
          listGlassInStore: res.data,
          totalGlassInStore: res.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách vật tư");
    }
  };
};
export const getListSupplierAPI = (page, limit) => {
  return async dispatch => {
    try {
      const res = await glassStoreService.getListSupplier(page, limit);
      dispatch(
        setListSupplier({
          listSupplier: res.data,
          total: res.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhà cung cấp");
    }
  };
};
export const getListXuatXuAPI = (page, limit) => {
  return async dispatch => {
    try {
      const res = await glassStoreService.getListXuatXu(page, limit);
      dispatch(
        setListXuatXu({
          listXuatXu: res.data,
          total: res.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nơi xuất xứ");
    }
  };
};

export const {
  setTypePhieu,
  setIdPhieu,
  setSelectGlassSupplies,
  setSelectGlassExport,
  setTypeForm,
  setStatusPhieu,
  setKhoXuatId,
  setListStore,
  setListStoreNhap,
  setListStoreXuat,
  setListGlassInStore,
  setListLoaiVT,
  setListSupplier,
  setListXuatXu,
  setSelectedRecord,
  setDetailRecord,
} = glassStoreSlice.actions;
export default glassStoreSlice.reducer;
